import { IntlErrorCode } from "@formatjs/intl";
const MISSING_DESCRIPTOR_ID = "no-descriptor";
const missingTranslationFingerprint = ({ error, locale, }) => [
    "i18n",
    IntlErrorCode.MISSING_TRANSLATION,
    String(error.descriptor?.id ?? MISSING_DESCRIPTOR_ID),
    locale,
];
export { missingTranslationFingerprint };
